import { buildSchema } from 'graphql';
import { delegateToSchema } from '@graphql-tools/delegate';
import { wrapSchema } from './wrapSchema';
export function makeRemoteExecutableSchema(_a) {
    var schemaOrTypeDefs = _a.schema, executor = _a.executor, subscriber = _a.subscriber, _b = _a.createResolver, createResolver = _b === void 0 ? defaultCreateRemoteResolver : _b, buildSchemaOptions = _a.buildSchemaOptions;
    var targetSchema = typeof schemaOrTypeDefs === 'string' ? buildSchema(schemaOrTypeDefs, buildSchemaOptions) : schemaOrTypeDefs;
    return wrapSchema({
        schema: targetSchema,
        createProxyingResolver: function () { return createResolver(executor, subscriber); },
    });
}
export function defaultCreateRemoteResolver(executor, subscriber) {
    return function (_parent, _args, context, info) {
        return delegateToSchema({
            schema: { schema: info.schema, executor: executor, subscriber: subscriber },
            context: context,
            info: info,
        });
    };
}
//# sourceMappingURL=makeRemoteExecutableSchema.js.map